<template>
	<div class="practice-container">
		<!-- Top Tabs -->
		<div class="top-tabs">
			<div class="tab-item" :class="{'active': detailType === 'answer'}" @click="switchToAnswerTab">
				问题解答
			</div>
			<div class="tab-item" :class="{'active': detailType === 'error'}" @click="switchToErrorTab">
				错题收集
			</div>
		</div>

		<!-- Main Content Area -->
		<div class="main-content">
			<!-- Left Panel - 问题列表 -->
			<div class="left-panel">
				<!-- 问题实时解答列表 -->
				<div v-if="detailType === 'answer'" class="chat-history-panel">
					<div class="panel-title-wrapper">
						<h2 class="panel-title">问题实时解答</h2>
						<button class="refresh-btn" @click="requestAnswerRecord()" title="刷新">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
							</svg>
						</button>
					</div>
					<div v-if="chatHistoryData.length === 0" class="empty-state">
						暂无对话历史
					</div>

					<div class="chat-list">
						<div
							v-for="(obj, index) in chatHistoryData"
							:key="index"
							class="chat-card"
							:class="{'active': currentObj === obj}"
							@click="selectChat(obj)"
						>
							<div class="chat-card-header">
								<span class="chat-type" :class="'type-' + obj.type">{{ obj.question }}</span>
								<span class="chat-time" style="width: 70px;">{{ obj.createTime }}</span>
							</div>
							<div>
								<span v-if="obj.answer == null" class="status-badge unrecognized">未识别</span>
								<span v-else class="status-badge recognized">识别</span>
							</div>
						</div>
					</div>

					<!-- 问题解答分页 -->
					<div v-if="answerPagination.total > answerPagination.pageSize" class="pagination-container">
						<div class="pagination">
							<button
								class="page-btn"
								:disabled="answerPagination.currentPage === 1"
								@click="handleAnswerPageChange(answerPagination.currentPage - 1)"
							>
								上一页
							</button>

							<span class="page-info">
								第 {{ answerPagination.currentPage }} 页，共 {{ Math.ceil(answerPagination.total / answerPagination.pageSize) }} 页
							</span>

							<button
								class="page-btn"
								:disabled="answerPagination.currentPage >= Math.ceil(answerPagination.total / answerPagination.pageSize)"
								@click="handleAnswerPageChange(answerPagination.currentPage + 1)"
							>
								下一页
							</button>
						</div>
					</div>
				</div>

			<!-- 错题收集列表 -->
			<div v-if="detailType === 'error'" class="error-record-panel">
				<div class="error-panel-header">
					<h2 class="panel-title">错题收集</h2>
					<button class="refresh-btn" @click="requestErrorRecord()" title="刷新">
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
							<path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
						</svg>
					</button>
				</div>
					<div v-if="errorRecordData.length === 0" class="empty-state">
						暂无错题记录
					</div>

					<div class="error-list">
						<div
							v-for="(obj, index) in errorRecordData"
							:key="index"
							class="error-card"
							:class="{'active': currentErrorObj === obj}"
							@click="selectErrorRecord(obj)"
						>
							<div class="error-card-header">
								<span class="error-type">错题记录</span>
								<span class="error-time">{{ obj.createTime }}</span>
							</div>

							<div class="error-content">
								<div>{{ obj.question }}</div>
								<div>
									<div class="error-summary">
										<span class="question-count">({{ obj.questionList.length }})</span>
									</div>

								</div>
							</div>

							<div class="error-media">
								<div class="image-item">
									<img
										:src="obj.orgImgUrl"
										class="thumbnail-img"
										@click.stop="showLargeImage(obj.orgImgUrl)"
										alt="Error record image"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- 错题收集分页 -->
					<div v-if="errorPagination.total > errorPagination.pageSize" class="pagination-container">
						<div class="pagination">
							<button
								class="page-btn"
								:disabled="errorPagination.currentPage === 1"
								@click="handleErrorPageChange(errorPagination.currentPage - 1)"
							>
								上一页
							</button>

							<span class="page-info">
								第 {{ errorPagination.currentPage }} 页，共 {{ Math.ceil(errorPagination.total / errorPagination.pageSize) }} 页
							</span>

							<button
								class="page-btn"
								:disabled="errorPagination.currentPage >= Math.ceil(errorPagination.total / errorPagination.pageSize)"
								@click="handleErrorPageChange(errorPagination.currentPage + 1)"
							>
								下一页
							</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Right Panel - 解答详情 -->
			<div class="right-panel">
				<div class="detail-panel">
					<h2 class="panel-title">解答详情</h2>

					<!-- 问题解答详情 -->
					<div v-if="detailType === 'answer' && currentObj && Object.keys(currentObj).length > 0" class="detail-content">

						<!-- 指令类型 -->
						<div>
							<div class="qa-section">
								<div class="detail-card">


									<div class="card-content">
									<div class="question-text">
										<div class="content-label">提问内容：</div>
										<div class="content-value tex2jax_process" v-html="formatAnswerContent(currentObj.question) || '暂无提问内容'"></div>
									</div>

										<div class="question-image">
											<div class="content-label">问题图片：</div>
											<div class="image-container question-img-container">
												<div class="question-content-layout">
													<div class="question-text-section">
														<div class="question-description tex2jax_process" v-html="formatAnswerContent(currentObj.questionsText)"></div>
													</div>
													<div class="question-image-section">
														<img
															v-if="currentObj.questionsCutImg"
															:src="currentObj.questionsCutImg"
															alt="Question image"
															class="question-img"
															@click="showLargeImage(currentObj.questionsCutImg)"
														/>
														<div v-else class="no-content">暂无问题图片</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="detail-card">
									<div class="card-header">
										<h3 class="detail-title">答案内容</h3>
									</div>

									<div class="card-content">
										<div class="answer-content tex2jax_process" v-html="formatAnswerContent(currentObj.answer) || '暂无答案内容'"></div>
									</div>
								</div>
							</div>

							<div class="image-section">
								<div class="detail-card">
									<div class="card-header">
										<h3 class="detail-title">图片详情</h3>
									</div>

									<div class="card-content">
										<div class="image-grid">
											<div class="image-item">
												<div class="image-container">
													<img
														v-if="currentObj.orgImgUrl"
														:src="currentObj.orgImgUrl"
														class="detail-img"
														@click="showLargeImage(currentObj.orgImgUrl)"
														alt="Original image"
													/>
													<div v-else class="no-image">无图片</div>
												</div>
												<div class="image-label">原始图片</div>
											</div>

											<div class="image-item">
												<div class="image-container">
													<img
														v-if="currentObj.dealImgUrl"
														:src="currentObj.dealImgUrl"
														class="detail-img"
														@click="showLargeImage(currentObj.dealImgUrl)"
														alt="Processed image"
													/>
													<div v-else class="no-image">无图片</div>
												</div>
												<div class="image-label">截取图片</div>
											</div>

											<div class="coordinate-container">
												<div class="coordinate-card">
													<div class="coordinate-icon"></div>
													<div class="coordinate-content">
														<div class="position-label">手指坐标</div>
														<div class="position-value">{{ currentObj.fingerPos || '暂无数据' }}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 错题收集详情 -->
					<div v-if="detailType === 'error' && currentErrorObj && Object.keys(currentErrorObj).length > 0" class="detail-content">
						<div class="qa-section">
							<div class="detail-card">
								<div class="card-header">
									<h3 class="detail-title">错题列表</h3>
								</div>

								<div class="card-content">
									<div v-if="currentErrorObj && currentErrorObj.questionList"
										class="question-list">
										<div v-for="(question, index) in currentErrorObj.questionList"
											:key="index"
											class="question-item">
											<div class="question-number">题目 {{ index + 1 }}</div>
											<div class="question-content-wrapper">
												<div v-if="question.paperCutImg" class="question-image-container">
													<img
														:src="question.paperCutImg"
														class="question-thumbnail"
														@click="showLargeImage(question.paperCutImg)"
														alt="Question image"
													/>
												</div>
											<div class="question-text-content tex2jax_process" v-html="formatAnswerContent(question.text)">
											</div>
											</div>
										</div>
									</div>
									<div v-else class="no-content">暂无错题数据</div>
								</div>
							</div>

							<div class="detail-card">
								<div class="card-header">
									<h3 class="detail-title">拍摄图片</h3>
								</div>

								<div class="card-content">
									<div class="image-grid">
										<div class="image-item">
											<div class="image-container">
												<img
													v-if="currentErrorObj && currentErrorObj.orgImgUrl"
													:src="currentErrorObj.orgImgUrl"
													class="detail-img"
													@click="showLargeImage(currentErrorObj.orgImgUrl)"
													alt="Original image"
												/>
												<div v-else class="no-image">无原始图片</div>
											</div>
											<div class="image-label">原始图片</div>
										</div>

										<div class="image-item">
											<div class="image-container">
												<img
													v-if="currentErrorObj && currentErrorObj.dealImgUrl"
													:src="currentErrorObj.dealImgUrl"
													class="detail-img"
													@click="showLargeImage(currentErrorObj.dealImgUrl)"
													alt="Processed image"
												/>
												<div v-else class="no-image">无处理图片</div>
											</div>
											<div class="image-label">处理图片</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 空状态 -->
					<div v-if="(detailType === 'answer' && (!currentObj || Object.keys(currentObj).length === 0)) ||
					          (detailType === 'error' && (!currentErrorObj || Object.keys(currentErrorObj).length === 0))"
					     class="detail-empty">
						<div class="empty-icon">📋</div>
						<div class="empty-text">
							<div v-if="detailType === 'answer'">请从左侧选择一个问题查看解答详情</div>
							<div v-else>请从左侧选择一个错题记录查看收集详情</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Image Modal -->
		<div v-if="showImageModal" class="image-modal" @click="closeImageModal">
			<div class="modal-content">
				<button class="close-btn" @click.stop="closeImageModal">×</button>
				<img :src="currentLargeImage" class="large-image" alt="Enlarged image" />
			</div>
		</div>

		<!-- Deal Status Modal -->
		<div v-if="showDealStatusModal" class="deal-status-modal">
			<div class="deal-status-content">
				<button class="deal-close-btn" @click="closeDealStatusModal">×</button>
				<div class="kaleidoscope-container">
					<div class="kaleidoscope">
						<div class="kaleidoscope-inner">
							<div class="kaleidoscope-segment" v-for="i in 8" :key="i" :style="{ transform: `rotate(${(i-1) * 45}deg)` }">
								<div class="kaleidoscope-piece"></div>
							</div>
						</div>
					</div>
				</div>
				<div class="deal-status-text">{{ dealStatusText }}</div>
				<div class="deal-status-text">正在处理中.....</div>
			</div>
		</div>

		<!-- Toast 提示 -->
		<div v-if="showToast" class="toast-notification" :class="toastType">
			<div class="toast-content">
				<span class="toast-icon">{{ toastType === 'success' ? '✓' : '✕' }}</span>
				<span class="toast-message">{{ toastMessage }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {axios} from "../../config/axios";

	export default {
		name: 'Practice',
		data() {
			return {
				questionImgUrl:'',
				chatHistoryData:[],
				errorRecordData:[],
				audioPlaying: {},
				currentAudio: null,
				showImageModal: false,
				currentLargeImage: '',
				currentObj:{},
				currentErrorObj:{},
				detailType: 'answer', // 'answer' 或 'error'
				// 分页相关数据
				answerPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				errorPagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},
				// 弹窗相关
				showDealStatusModal: false,
				dealStatusText: '',
				// Toast 提示相关
				showToast: false,
				toastMessage: '',
				toastType: 'success',
				toastTimer: null
			}
		},
		created() {
			this.getData();
			this.loadMathJax();
		},
		mounted() {
			this.$nextTick(() => {
				this.renderMath();
			});
		},
		updated() {
			this.$nextTick(() => {
				this.renderMath();
			});
		},
		beforeUnmount() {
		},
		methods: {
			// 切换到问题解答标签
			switchToAnswerTab() {
				this.detailType = 'answer';
				this.requestAnswerRecord();
				// 重新渲染数学公式
				this.$nextTick(() => {
					this.renderMath();
				});
			},
			// 切换到错题收集标签
			switchToErrorTab() {
				this.detailType = 'error';
				this.requestErrorRecord();
				// 重新渲染数学公式
				this.$nextTick(() => {
					this.renderMath();
				});
			},
			// 问题解答分页处理
			handleAnswerPageChange(page) {
				console.log(`问题解答分页点击 - 目标页码: ${page}, 当前页码: ${this.answerPagination.currentPage}`);
				this.requestAnswerRecord(page);
			},
			// 错题收集分页处理
			handleErrorPageChange(page) {
				console.log(`错题收集分页点击 - 目标页码: ${page}, 当前页码: ${this.errorPagination.currentPage}`);
				this.requestErrorRecord(page);
			},
			selectChat(obj) {
				this.currentObj = obj;
				// 自动切换到问题解答详情标签
				this.detailType = 'answer';
				// 重新渲染数学公式
				this.$nextTick(() => {
					this.renderMath();
				});
			},
		selectErrorRecord(obj) {
			this.currentErrorObj = obj;
			// 自动切换到错题收集详情标签
			this.detailType = 'error';
			// 重新渲染数学公式
			this.$nextTick(() => {
				this.renderMath();
			});
		},

			getData () {
				this.requestAnswerRecord();
				this.requestErrorRecord();
			},
			// 获取问题实时解答数据
			requestAnswerRecord(page = 1) {
				console.log(`请求问题解答数据 - 页码: ${page}, 后端页码: ${page - 1}, 页面大小: ${this.answerPagination.pageSize}`);

				const requestParams = {
					pageNumber: page - 1, // 后端从0开始计数
					pageSize: this.answerPagination.pageSize
				};
				console.log('请求参数:', requestParams);

				axios.get('/requestAnswerRecord', {
					params: requestParams
				}).then(response => {
					console.info("问题实时解答数据响应:", response);
					let res = response.data;
					if (res.code != 200){
						console.error('请求失败:', res)
						return;
					}

					console.log('响应数据:', res.data);
					this.chatHistoryData = res.data.list || [];

					// 更新分页信息
					const oldCurrentPage = this.answerPagination.currentPage;
					const oldTotal = this.answerPagination.total;

					this.answerPagination.currentPage = page;
					this.answerPagination.total = res.data.total || 0;

					console.log(`分页信息更新 - 旧页码: ${oldCurrentPage} -> 新页码: ${this.answerPagination.currentPage}, 旧总数: ${oldTotal} -> 新总数: ${this.answerPagination.total}`);
					console.log('数据列表长度:', this.chatHistoryData.length);

					if (this.chatHistoryData && this.chatHistoryData.length > 0) {
						this.currentObj = this.chatHistoryData[0];
					}
					console.info("当前选中对象:",this.currentObj )

					// 重新渲染数学公式
					this.$nextTick(() => {
						this.renderMath();
					});

					// 显示成功提示
					this.showToastMessage('刷新成功', 'success');
				}).catch(err => {
					console.error('请求错误:', err);
					this.showToastMessage('刷新失败', 'error');
				});
			},
			// 获取错题收集数据
			requestErrorRecord(page = 1) {
				console.log(`请求错题收集数据 - 页码: ${page}, 后端页码: ${page - 1}, 页面大小: ${this.errorPagination.pageSize}`);

				const requestParams = {
					pageNumber: page - 1, // 后端从0开始计数
					pageSize: this.errorPagination.pageSize
				};
				console.log('错题请求参数:', requestParams);

				axios.get('/requestErrorRecord', {
					params: requestParams
				}).then(response => {
					console.info("错题收集数据响应:", response);
					let res = response.data;
					if (res.code != 200){
						console.error('错题请求失败:', res)
						return;
					}

					console.log('错题响应数据:', res.data);
					this.errorRecordData = res.data.list || [];

					// 更新分页信息
					const oldCurrentPage = this.errorPagination.currentPage;
					const oldTotal = this.errorPagination.total;

					this.errorPagination.currentPage = page;
					this.errorPagination.total = res.data.total || 0;

					console.log(`错题分页信息更新 - 旧页码: ${oldCurrentPage} -> 新页码: ${this.errorPagination.currentPage}, 旧总数: ${oldTotal} -> 新总数: ${this.errorPagination.total}`);
					console.log('错题数据列表长度:', this.errorRecordData.length);

					if (this.errorRecordData && this.errorRecordData.length > 0) {
						this.currentErrorObj = this.errorRecordData[0];
					}
					console.info("当前选中错题对象:",this.currentErrorObj )

					// 重新渲染数学公式
					this.$nextTick(() => {
						this.renderMath();
					});

					// 显示成功提示
					this.showToastMessage('刷新成功', 'success');
				}).catch(err => {
					console.error('错题请求错误:', err);
					this.showToastMessage('刷新失败', 'error');
				});
			},
			showType(type){
				if (type == 1){
					return "对话";
				} else if (type == 2){
					return "指令";
				} else if (type == 3) {
					return "错题";
				}
				return "_"
			},
			toggleAudio(obj, index) {
				const audio = document.getElementById(`audio-${index}`);

				// If there's another audio playing, stop it first
				if (this.currentAudio && this.currentAudio !== audio) {
					this.currentAudio.pause();
					this.currentAudio.currentTime = 0;
					const prevIndex = Object.keys(this.audioPlaying).find(key => this.audioPlaying[key] === true);
					if (prevIndex) this.$set(this.audioPlaying, prevIndex, false);
				}

				if (!this.audioPlaying[index]) {
					// Play this audio
					audio.play().then(() => {
						this.$set(this.audioPlaying, index, true);
						this.currentAudio = audio;

						// When audio ends, reset state
						audio.onended = () => {
							this.$set(this.audioPlaying, index, false);
							this.currentAudio = null;
						};
					}).catch(e => {
						console.error('Error playing audio:', e);
					});
				} else {
					// Pause this audio
					audio.pause();
					audio.currentTime = 0;
					this.$set(this.audioPlaying, index, false);
					this.currentAudio = null;
				}
			},
			showLargeImage(imageUrl) {
				this.currentLargeImage = imageUrl;
				this.showImageModal = true;
			},

			closeImageModal() {
				this.showImageModal = false;
				this.currentLargeImage = '';
			},

		// MathJax相关方法
		loadMathJax() {
			// MathJax已在index.html中预加载，这里只需要等待其加载完成
			const checkMathJax = () => {
				if (window.MathJax && window.MathJax.typesetPromise) {
					console.log('MathJax已就绪');
					this.renderMath();
				} else {
					// 如果MathJax还未加载完成，等待100ms后再检查
					setTimeout(checkMathJax, 100);
				}
			};
			checkMathJax();
		},

		renderMath() {
			this.$nextTick(() => {
				if (window.MathJax && window.MathJax.typesetPromise) {
					// 获取所有需要渲染的元素
					const elements = document.querySelectorAll('.tex2jax_process');
					if (elements.length > 0) {
						// 清除之前的MathJax渲染
						window.MathJax.typesetClear(Array.from(elements));
						// 重新渲染
						window.MathJax.typesetPromise(Array.from(elements))
							.then(() => {
								console.log('MathJax渲染成功');
							})
							.catch((err) => {
								console.error('MathJax渲染错误:', err);
							});
					}
				} else {
					console.warn('MathJax未加载或未就绪');
				}
			});
		},

			// 格式化答案内容，处理LaTeX公式
			formatAnswerContent(content) {
				if (!content) return '';

				// 解码HTML实体
				let formattedContent = content
					.replace(/&lt;/g, '<')
					.replace(/&gt;/g, '>')
					.replace(/&quot;/g, '"')
					.replace(/&#39;/g, "'")
					.replace(/&amp;/g, '&');

				// 将 \[ \] 转换为 $$ $$（块级公式）
				formattedContent = formattedContent.replace(/\\\[([\s\S]*?)\\\]/g, (match, p1) => {
					return '$$' + p1 + '$$';
				});

				// 将 \( \) 转换为 $ $（行内公式）
				formattedContent = formattedContent.replace(/\\\(([\s\S]*?)\\\)/g, (match, p1) => {
					return '$' + p1 + '$';
				});

				// 处理换行符，使其在HTML中正确显示
				formattedContent = formattedContent.replace(/\n/g, '<br/>');

				return formattedContent;
			},

			// 关闭处理状态弹窗
			closeDealStatusModal() {
				axios.get('/page/flashStatus', {
					params: {}
				}).then(response => {
					console.info("flashStatus响应:", response);
					let res = response.data;
					if (res.code === 200) {
						// 状态200，关闭弹窗
						this.showDealStatusModal = false;
						this.dealStatusText = '';
						console.log('FlashStatus返回200 - 关闭弹窗');
					} else {
						console.log('FlashStatus未返回200，弹窗保持打开');
					}
				}).catch(err => {
					console.error('flashStatus请求错误:', err);
				});
			},

			// 显示 Toast 提示
			showToastMessage(message, type = 'success') {
				// 清除之前的定时器
				if (this.toastTimer) {
					clearTimeout(this.toastTimer);
				}

				this.toastMessage = message;
				this.toastType = type;
				this.showToast = true;

				// 2秒后自动隐藏
				this.toastTimer = setTimeout(() => {
					this.showToast = false;
					this.toastTimer = null;
				}, 2000);
			}
		}
	}
</script>

<style scoped>
	/* Main Layout */
	.practice-container {
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: 100vh;
		padding: 24px;
		background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
		color: #333;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
		overflow: hidden;
	}

	/* Top Tabs */
	.top-tabs {
		display: flex;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		border-radius: 16px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.2);
		overflow: hidden;
	}

	.tab-item {
		flex: 1;
		padding: 18px 24px;
		text-align: center;
		cursor: pointer;
		font-weight: 600;
		color: #64748b;
		border-bottom: 3px solid transparent;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		position: relative;
		overflow: hidden;
	}

	.tab-item::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		opacity: 0;
		transition: opacity 0.3s ease;
		z-index: -1;
	}

	.tab-item:hover {
		color: #1e293b;
		transform: translateY(-1px);
	}

	.tab-item:hover::before {
		opacity: 0.05;
	}

	.tab-item.active {
		background: rgba(255, 255, 255, 0.9);
		color: #1976d2;
		border-bottom-color: #2196f3;
		box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
	}

	/* Main Content */
	.main-content {
		display: flex;
		flex-direction: row;
		gap: 5%;
		flex: 1;
		overflow: hidden;
	}

	/* Left Panel */
	.left-panel {
		flex: 0 0 25%;
		width: 25%;
		display: flex;
		flex-direction: column;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		border-radius: 16px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.2);
		overflow: hidden;
		transition: transform 0.2s ease, box-shadow 0.2s ease;
	}

	.left-panel:hover {
		transform: translateY(-2px);
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
	}

	/* Right Panel */
	.right-panel {
		flex: 0 0 74%;
		width: 74%;
		display: flex;
		flex-direction: column;
	}

	.detail-panel {
		flex: 1;
		display: flex;
		flex-direction: column;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		border-radius: 16px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.2);
		overflow: hidden;
		transition: transform 0.2s ease, box-shadow 0.2s ease;
	}

	.detail-panel:hover {
		transform: translateY(-1px);
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
	}

	/* Panel Styles */
	.chat-history-panel,
	.error-record-panel {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.panel-title-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 20px;
		border-bottom: 1px solid rgba(234, 237, 242, 0.5);
		background: rgba(248, 250, 252, 0.8);
	}

	.panel-title {
		margin: 0;
		padding: 0;
		font-size: 18px;
		font-weight: 600;
		color: #2c3e50;
	}

	.chat-history-panel .panel-title {
		border-bottom: none;
		background: none;
		padding: 0;
	}

	.error-panel-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 20px;
		border-bottom: 1px solid rgba(234, 237, 242, 0.5);
		background: rgba(248, 250, 252, 0.8);
	}

	.error-record-panel .panel-title {
		padding: 0;
		margin: 0;
		border-bottom: none;
		background: none;
	}

	.refresh-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		flex-shrink: 0;
		background: rgba(255, 255, 255, 0.9);
		border: 1px solid rgba(33, 150, 243, 0.3);
		border-radius: 6px;
		color: #2196f3;
		cursor: pointer;
		transition: all 0.3s ease;
		padding: 0;
	}

	.refresh-btn:hover {
		background: rgba(33, 150, 243, 0.1);
		border-color: #2196f3;
		transform: rotate(180deg);
	}

	.refresh-btn:active {
		transform: rotate(180deg) scale(0.95);
	}

	.status-badge {
		display: flex;
		align-items: center;
		margin: 16px 20px 0;
		padding: 6px 12px;
		border-radius: 16px;
		font-size: 14px;
		font-weight: 500;
	}

	.status-icon {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		margin-right: 8px;
	}

	.status-badge.connected {
		background-color: #e6f7e6;
		color: #2e7d32;
	}

	.status-badge.connected .status-icon {
		background-color: #4caf50;
	}

	.status-badge.disconnected, .status-badge.closed {
		background-color: #f5f5f5;
		color: #757575;
	}

	.status-badge.disconnected .status-icon, .status-badge.closed .status-icon {
		background-color: #9e9e9e;
	}

	.status-badge.connecting {
		background-color: #e3f2fd;
		color: #1976d2;
	}

	.status-badge.connecting .status-icon {
		background-color: #2196f3;
	}

	.status-badge.error {
		background-color: #feeceb;
		color: #d32f2f;
	}

	.status-badge.error .status-icon {
		background-color: #f44336;
	}

	/* Recognition Status Badges */
	.status-badge.recognized {
		display: inline-flex;
		align-items: center;
		padding: 4px 8px;
		margin: 0;
		font-size: 12px;
		font-weight: 500;
		border-radius: 12px;
		background-color: #e8f5e8;
		color: #2e7d32;
		border: 1px solid #c8e6c9;
	}

	.status-badge.unrecognized {
		display: inline-flex;
		align-items: center;
		padding: 4px 8px;
		margin: 0;
		font-size: 12px;
		font-weight: 500;
		border-radius: 12px;
		background-color: #fff3e0;
		color: #f57c00;
		border: 1px solid #ffcc02;
	}

	/* Lists */
	.chat-list,
	.error-list {
		flex: 1;
		overflow-y: auto;
		padding: 12px;
	}

	.empty-state {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 200px;
		color: #9e9e9e;
		font-style: italic;
	}

	/* Cards */
	.chat-card,
	.error-card {
		margin-bottom: 12px;
		padding: 16px;
		background: rgba(248, 250, 252, 0.5);
		border-radius: 12px;
		border-left: 4px solid #e0e0e0;
		cursor: pointer;
		transition: all 0.3s ease;
		backdrop-filter: blur(5px);
	}

	.chat-card:hover,
	.error-card:hover {
		background: rgba(239, 246, 255, 0.9);
		border-left-color: #90caf9;
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
	}

	.chat-card.active {
		background: rgba(227, 242, 253, 0.9);
		border-left-color: #2196f3;
		box-shadow: 0 4px 16px rgba(33, 150, 243, 0.2);
	}

	.error-card {
		background: rgba(255, 248, 240, 0.5);
	}

	.error-card:hover {
		background: rgba(255, 243, 224, 0.9);
		border-left-color: #f57c00;
	}

	.error-card.active {
		background: rgba(255, 243, 224, 0.9);
		border-left-color: #e65100;
		box-shadow: 0 4px 16px rgba(255, 152, 0, 0.2);
	}

	.chat-card-header,
	.error-card-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 8px;
	}

	.chat-type,
	.error-type {
		font-weight: 600;
		font-size: 14px;
		padding: 2px 8px;
		border-radius: 4px;
	}

	.chat-type.type-1 {
		background: #e3f2fd;
		color: #1976d2;
	}

	.chat-type.type-2 {
		background: #e8f5e9;
		color: #2e7d32;
	}

	.chat-type.type-3,
	.error-type {
		background: #fff3e0;
		color: #e65100;
	}

	.chat-time,
	.error-time {
		font-size: 12px;
		color: #757575;
	}

	.chat-content,
	.error-content {
		margin-bottom: 12px;
		font-size: 14px;
		line-height: 1.5;
		color: #333;
		word-break: break-word;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
	}

	.chat-media,
	.error-media {
		display: flex;
		gap: 12px;
		align-items: center;
	}

	/* Detail Content */
	.detail-content {
		flex: 1;
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		overflow-y: auto;
	}

	.detail-empty {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #9e9e9e;
		padding: 40px;
	}

	.empty-icon {
		font-size: 48px;
		margin-bottom: 16px;
		opacity: 0.6;
	}

	.empty-text {
		font-size: 16px;
		font-style: italic;
		text-align: center;
	}

	.qa-section,
	.image-section {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.detail-card {
		background: rgba(255, 255, 255, 0.9);
		backdrop-filter: blur(8px);
		border-radius: 12px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
		border: 1px solid rgba(255, 255, 255, 0.3);
		overflow: hidden;
		transition: all 0.3s ease;
	}

	.detail-card:hover {
		transform: translateY(-2px);
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 20px;
		background: rgba(248, 250, 252, 0.8);
		border-bottom: 1px solid rgba(234, 237, 242, 0.5);
	}

	.detail-title {
		margin: 0;
		font-size: 16px;
		font-weight: 600;
		color: #2c3e50;
	}

	.card-content {
		padding: 20px;
	}

	/* Question and Answer Content */
	.question-text,
	.question-image {
		margin-bottom: 20px;
	}

	.content-label {
		font-weight: 500;
		margin-bottom: 8px;
		color: #616161;
	}

	.content-value {
		padding: 12px;
		background-color: rgba(245, 247, 250, 0.8);
		border-radius: 8px;
		line-height: 1.6;
		overflow-x: auto;
	}

	.answer-content {
		line-height: 1.6;
		padding: 16px;
		background-color: rgba(249, 249, 249, 0.8);
		border-radius: 8px;
		white-space: pre-line;
		font-size: 15px;
	}

	/* MathJax数学公式样式 */
	.answer-content .MathJax {
		display: inline-block !important;
		margin: 0.2em 0;
	}

	.answer-content .MathJax_Display {
		text-align: center !important;
		margin: 1em 0 !important;
		padding: 0.5em 0;
	}

	/* 确保数学公式在容器内正确显示 */
	.tex2jax_process {
		overflow-x: auto;
		overflow-y: visible;
	}

	/* 问题内容布局样式 */
	.question-content-layout {
		display: flex;
		gap: 20px;
		align-items: flex-start;
		min-height: 200px;
	}

	.question-text-section {
		flex: 1;
		padding-right: 10px;
	}

	.question-description {
		font-size: 15px;
		line-height: 1.6;
		color: #333;
		background: rgba(248, 250, 252, 0.8);
		padding: 16px;
		border-radius: 8px;
		border-left: 4px solid #2196f3;
		overflow-x: auto;
	}

	/* MathJax 渲染样式 */
	.tex2jax_process {
		word-wrap: break-word;
		overflow-wrap: break-word;
	}

	.tex2jax_process .MJX-TEX {
		font-size: 1.1em;
	}

	.tex2jax_process mjx-container {
		display: inline-block;
		margin: 0 2px;
	}

	.tex2jax_process mjx-container[display="true"] {
		display: block;
		text-align: center;
		margin: 1em 0;
	}

	.question-image-section {
		flex: 0 0 300px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.question-image-section .question-img {
		max-width: 100%;
		max-height: 250px;
		object-fit: contain;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		cursor: pointer;
		transition: transform 0.2s ease;
	}

	.question-image-section .question-img:hover {
		transform: scale(1.02);
	}

	/* Simple panel styles for type 1 */
	.simple-panel {
		max-width: 100%;
	}

	.conversation-simple {
		padding: 5px 0;
	}

	.conversation-item {
		padding: 16px 0;
	}

	.item-label {
		font-weight: 600;
		color: #555;
		margin-bottom: 10px;
		font-size: 15px;
	}

	.item-content {
		line-height: 1.6;
		color: #333;
		padding: 0 5px;
		white-space: pre-line;
	}

	.answer-content-display {
		background: rgba(249, 249, 249, 0.8);
		padding: 12px;
		border-radius: 6px;
		border-left: 3px solid #2196f3;
		margin-top: 8px;
	}

	.item-time {
		margin-top: 8px;
		font-size: 12px;
		color: #888;
		text-align: right;
	}

	.conversation-divider {
		height: 1px;
		background-color: rgba(238, 238, 238, 0.8);
		margin: 5px 0;
	}

	/* Images */
	.image-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}

	.image-item {
		flex: 1;
		min-width: 200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.image-container {
		width: 100%;
		height: 160px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(245, 247, 250, 0.8);
		border-radius: 8px;
		overflow: hidden;
		margin-bottom: 8px;
	}

	.question-img-container {
		height: auto;
		min-height: 120px;
	}

	.detail-img,
	.question-img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		cursor: pointer;
		transition: transform 0.2s;
		border-radius: 8px;
	}

	.detail-img:hover,
	.question-img:hover {
		transform: scale(1.05);
	}

	.no-image,
	.no-content {
		color: #9e9e9e;
		font-style: italic;
	}

	.image-label {
		font-size: 14px;
		color: #616161;
		margin-top: 8px;
	}

	.thumbnail-img {
		width: 60px;
		height: 60px;
		object-fit: cover;
		border-radius: 6px;
		cursor: pointer;
		border: 2px solid #e0e0e0;
		transition: all 0.2s;
	}

	.thumbnail-img:hover {
		border-color: #2196f3;
		transform: scale(1.05);
	}

	/* Coordinate Display */
	.coordinate-container {
		flex: 1;
		min-width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.coordinate-card {
		width: 100%;
		display: flex;
		gap: 12px;
		padding: 16px;
		background: rgba(240, 244, 248, 0.8);
		border-radius: 10px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
	}

	.coordinate-icon {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		background-color: #e3f2fd;
		border-radius: 8px;
		position: relative;
	}

	.coordinate-icon:before {
		content: "";
		position: absolute;
		top: 8px;
		left: 8px;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background-color: #2196f3;
	}

	.coordinate-content {
		flex: 1;
	}

	.position-label {
		font-weight: 500;
		color: #616161;
		margin-bottom: 8px;
	}

	.position-value {
		font-family: monospace;
		background: rgba(232, 234, 246, 0.8);
		padding: 8px;
		border-radius: 4px;
		word-break: break-all;
	}

	/* Audio Button */
	.audio-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 6px 12px;
		background-color: #2196f3;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 13px;
		transition: background-color 0.2s;
	}

	.audio-btn:hover {
		background-color: #1976d2;
	}

	.audio-icon {
		display: inline-block;
		width: 12px;
		height: 12px;
		background-color: #ffffff;
		border-radius: 50%;
		position: relative;
	}

	.audio-icon.playing::before {
		content: "";
		position: absolute;
		top: 3px;
		left: 3px;
		right: 3px;
		bottom: 3px;
		background-color: #2196f3;
		border-radius: 50%;
		animation: pulse 1s infinite;
	}

	@keyframes pulse {
		0% { transform: scale(0.8); opacity: 0.8; }
		50% { transform: scale(1.2); opacity: 1; }
		100% { transform: scale(0.8); opacity: 0.8; }
	}

	/* Question List Styles */
	.question-list {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.question-item {
		padding: 16px;
		background: rgba(248, 249, 250, 0.8);
		border-radius: 8px;
	}

	.question-number {
		font-weight: 600;
		color: #e65100;
		margin-bottom: 8px;
		font-size: 14px;
	}

	.question-content-wrapper {
		display: flex;
		align-items: flex-start;
		gap: 16px;
		margin-top: 12px;
	}

	.question-text-content {
		flex: 1;
		color: #333;
		line-height: 1.6;
		font-size: 14px;
		padding: 8px 0;
		overflow-x: auto;
		word-wrap: break-word;
	}

	.question-image-container {
		flex: 0 0 auto;
		width: 120px;
	}

	.question-thumbnail {
		width: 100%;
		height: auto;
		border-radius: 6px;
		cursor: pointer;
		transition: transform 0.2s;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	}

	.question-thumbnail:hover {
		transform: scale(1.05);
	}

	.error-summary {
		margin-bottom: 8px;
	}

	.question-count {
		background: rgba(255, 243, 224, 0.8);
		color: #e65100;
		padding: 2px 8px;
		border-radius: 12px;
		font-size: 12px;
		font-weight: 500;
	}

	.error-preview {
		color: #666;
		font-size: 13px;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 200px;
	}

	.no-questions {
		color: #999;
		font-style: italic;
		font-size: 13px;
	}

	/* Modal */
	.image-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.85);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		cursor: pointer;
		backdrop-filter: blur(3px);
	}

	.modal-content {
		position: relative;
		max-width: 90%;
		max-height: 90%;
		animation: fadeIn 0.3s;
	}

	.close-btn {
		position: absolute;
		top: -40px;
		right: -40px;
		width: 36px;
		height: 36px;
		background: rgba(255, 255, 255, 0.2);
		color: white;
		border: none;
		border-radius: 50%;
		font-size: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background 0.2s;
	}

	.close-btn:hover {
		background: rgba(255, 255, 255, 0.4);
	}

	.large-image {
		max-width: 100%;
		max-height: 90vh;
		border-radius: 8px;
		box-shadow: 0 0 30px rgba(0, 0, 0, 0.7);
	}

	@keyframes fadeIn {
		from { opacity: 0; transform: scale(0.95); }
		to { opacity: 1; transform: scale(1); }
	}

	/* Deal Status Modal */
	.deal-status-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1001;
		backdrop-filter: blur(3px);
		animation: fadeIn 0.3s ease;
	}

	.deal-status-content {
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		border-radius: 16px;
		padding: 40px 60px;
		box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
		border: 1px solid rgba(255, 255, 255, 0.3);
		animation: slideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1);
		min-width: 300px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;
		position: relative;
	}

	.deal-close-btn {
		position: absolute;
		top: 12px;
		right: 12px;
		width: 32px;
		height: 32px;
		background: rgba(0, 0, 0, 0.1);
		color: #666;
		border: none;
		border-radius: 50%;
		font-size: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.2s ease;
		line-height: 1;
		padding: 0;
	}

	.deal-close-btn:hover {
		background: rgba(0, 0, 0, 0.2);
		color: #333;
		transform: rotate(90deg);
	}

	/* Toast 提示样式 */
	.toast-notification {
		position: fixed;
		top: 80px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2000;
		animation: slideDown 0.3s ease-out;
	}

	.toast-content {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 12px 24px;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		border-radius: 8px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
		border: 1px solid rgba(76, 175, 80, 0.3);
	}

	.toast-notification.success .toast-content {
		border-color: rgba(76, 175, 80, 0.5);
	}

	.toast-notification.error .toast-content {
		border-color: rgba(244, 67, 54, 0.5);
	}

	.toast-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		font-size: 14px;
		font-weight: bold;
	}

	.toast-notification.success .toast-icon {
		background: #4caf50;
		color: white;
	}

	.toast-notification.error .toast-icon {
		background: #f44336;
		color: white;
	}

	.toast-message {
		font-size: 14px;
		font-weight: 500;
		color: #2c3e50;
	}

	@keyframes slideDown {
		from {
			opacity: 0;
			transform: translateX(-50%) translateY(-20px);
		}
		to {
			opacity: 1;
			transform: translateX(-50%) translateY(0);
		}
	}

	.kaleidoscope-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.kaleidoscope {
		width: 80px;
		height: 80px;
		position: relative;
		animation: kaleidoscopeRotate 3s linear infinite;
	}

	.kaleidoscope-inner {
		width: 100%;
		height: 100%;
		position: relative;
		border-radius: 50%;
		overflow: hidden;
	}

	.kaleidoscope-segment {
		position: absolute;
		width: 50%;
		height: 50%;
		top: 50%;
		left: 50%;
		transform-origin: 0 0;
		overflow: hidden;
	}

	.kaleidoscope-piece {
		width: 100%;
		height: 100%;
		background: linear-gradient(45deg,
			#ff6b6b 0%,
			#4ecdc4 25%,
			#45b7d1 50%,
			#96ceb4 75%,
			#ffeaa7 100%);
		border-radius: 0 100% 0 0;
		animation: kaleidoscopePulse 2s ease-in-out infinite alternate;
		opacity: 0.8;
	}

	.kaleidoscope-segment:nth-child(1) .kaleidoscope-piece {
		background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
		animation-delay: 0s;
	}

	.kaleidoscope-segment:nth-child(2) .kaleidoscope-piece {
		background: linear-gradient(45deg, #4ecdc4, #45b7d1);
		animation-delay: 0.25s;
	}

	.kaleidoscope-segment:nth-child(3) .kaleidoscope-piece {
		background: linear-gradient(45deg, #45b7d1, #96ceb4);
		animation-delay: 0.5s;
	}

	.kaleidoscope-segment:nth-child(4) .kaleidoscope-piece {
		background: linear-gradient(45deg, #96ceb4, #ffeaa7);
		animation-delay: 0.75s;
	}

	.kaleidoscope-segment:nth-child(5) .kaleidoscope-piece {
		background: linear-gradient(45deg, #ffeaa7, #fd79a8);
		animation-delay: 1s;
	}

	.kaleidoscope-segment:nth-child(6) .kaleidoscope-piece {
		background: linear-gradient(45deg, #fd79a8, #fdcb6e);
		animation-delay: 1.25s;
	}

	.kaleidoscope-segment:nth-child(7) .kaleidoscope-piece {
		background: linear-gradient(45deg, #fdcb6e, #6c5ce7);
		animation-delay: 1.5s;
	}

	.kaleidoscope-segment:nth-child(8) .kaleidoscope-piece {
		background: linear-gradient(45deg, #6c5ce7, #ff6b6b);
		animation-delay: 1.75s;
	}

	.deal-status-text {
		font-size: 20px;
		font-weight: 600;
		color: #2c3e50;
		text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		letter-spacing: 1px;
		margin-top: 10px;
	}

	@keyframes kaleidoscopeRotate {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes kaleidoscopePulse {
		0% {
			opacity: 0.6;
			transform: scale(0.8);
		}
		100% {
			opacity: 1;
			transform: scale(1.2);
		}
	}

	@keyframes slideIn {
		from {
			opacity: 0;
			transform: translateY(-30px) scale(0.9);
		}
		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	/* Pagination Styles */
	.pagination-container {
		padding: 16px 20px;
		border-top: 1px solid rgba(234, 237, 242, 0.5);
		background: rgba(248, 250, 252, 0.8);
	}

	.pagination {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 16px;
	}

	.page-btn {
		padding: 8px 16px;
		background: rgba(255, 255, 255, 0.9);
		border: 1px solid rgba(33, 150, 243, 0.3);
		border-radius: 6px;
		color: #2196f3;
		cursor: pointer;
		font-size: 14px;
		font-weight: 500;
		transition: all 0.3s ease;
		backdrop-filter: blur(5px);
	}

	.page-btn:hover:not(:disabled) {
		background: rgba(33, 150, 243, 0.1);
		border-color: #2196f3;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
	}

	.page-btn:disabled {
		background: rgba(245, 245, 245, 0.8);
		border-color: rgba(189, 189, 189, 0.5);
		color: #bdbdbd;
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}

	.page-info {
		font-size: 14px;
		color: #616161;
		font-weight: 500;
		padding: 0 8px;
		white-space: nowrap;
	}

	/* Scrollbar styling */
	.chat-list::-webkit-scrollbar,
	.error-list::-webkit-scrollbar,
	.detail-content::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.chat-list::-webkit-scrollbar-track,
	.error-list::-webkit-scrollbar-track,
	.detail-content::-webkit-scrollbar-track {
		background: rgba(241, 241, 241, 0.8);
		border-radius: 4px;
	}

	.chat-list::-webkit-scrollbar-thumb,
	.error-list::-webkit-scrollbar-thumb,
	.detail-content::-webkit-scrollbar-thumb {
		background: rgba(189, 189, 189, 0.8);
		border-radius: 4px;
	}

	.chat-list::-webkit-scrollbar-thumb:hover,
	.error-list::-webkit-scrollbar-thumb:hover,
	.detail-content::-webkit-scrollbar-thumb:hover {
		background: rgba(158, 158, 158, 0.9);
	}

	/* Responsive Design */
	@media screen and (max-width: 1200px) {
		.practice-container {
			padding: 20px;
			gap: 16px;
		}

		.main-content {
			gap: 3%;
		}

		.left-panel {
			flex: 0 0 30%;
			width: 30%;
		}

		.right-panel {
			flex: 0 0 67%;
			width: 67%;
		}
	}

	@media screen and (max-width: 992px) {
		.main-content {
			flex-direction: column;
		}

		.left-panel,
		.right-panel {
			flex: none;
			height: 300px;
		}

		.right-panel {
			height: 400px;
		}

		.image-grid {
			flex-direction: column;
		}

		.image-item {
			width: 100%;
			margin-bottom: 15px;
		}

		.coordinate-container {
			width: 100%;
		}

		.close-btn {
			top: 0;
			right: 0;
		}
	}

	@media screen and (max-width: 768px) {
		.practice-container {
			padding: 16px;
			gap: 12px;
		}

		.tab-item {
			padding: 14px 20px;
			font-size: 14px;
		}

		.left-panel,
		.right-panel {
			height: 250px;
		}

		.question-content-wrapper {
			flex-direction: column;
			gap: 12px;
		}

		.question-image-container {
			width: 100%;
			max-width: 200px;
		}

		.question-text-content {
			font-size: 13px;
		}

		/* 响应式问题内容布局 */
		.question-content-layout {
			flex-direction: column;
			gap: 16px;
			min-height: auto;
		}

		.question-text-section {
			padding-right: 0;
		}

		.question-image-section {
			flex: none;
			width: 100%;
		}

		.question-image-section .question-img {
			max-height: 200px;
		}
	}

	@media screen and (max-width: 576px) {
		.practice-container {
			padding: 12px;
			gap: 10px;
		}

		.card-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 8px;
		}

		.chat-type {
			margin-bottom: 5px;
		}

		.chat-card,
		.error-card {
			padding: 12px;
		}

		.panel-title {
			padding: 12px 16px;
			font-size: 16px;
		}

		.status-badge {
			margin: 12px 16px 0;
		}

		.detail-title {
			font-size: 15px;
		}

		.item-label,
		.content-label {
			font-size: 14px;
		}

		.item-content,
		.content-value {
			font-size: 13px;
		}
	}
</style>
